import { FastField } from 'formik';
import { FormField, Input } from '@shipengine/formik-giger';
import { useTranslation } from '@packlink/translation-provider';
import { FieldNames } from './InvoiceForm.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { useDisabledFields } from '../contexts/disabledFields.js';

const InvoiceCompanyForm = () => {
  const {
    t
  } = useTranslation();
  const {
    isFieldDisabled
  } = useDisabledFields();
  return jsxs("div", {
    "aria-label": "company-info",
    children: [jsx(FormField, {
      name: FieldNames.COMPANYNAME,
      children: jsx(FastField, {
        disabled: isFieldDisabled(FieldNames.COMPANYNAME),
        component: Input,
        label: t('invoice-form.label.company-name')
      })
    }), jsx(FormField, {
      name: FieldNames.TAXID,
      children: jsx(FastField, {
        disabled: isFieldDisabled(FieldNames.TAXID),
        component: Input,
        label: t('invoice-form.label.tax-id')
      })
    })]
  });
};
var InvoiceCompanyForm$1 = InvoiceCompanyForm;

export { InvoiceCompanyForm$1 as default };
//# sourceMappingURL=InvoiceCompanyForm.js.map
